import { Directive } from '@angular/core';

@Directive({
    selector: `[apxTab]`,
    standalone: true
})
export class ApxTabDirective {}
